const LANGUAGE_SERVER_CODE_MAP = {
    "en": 0
}

export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_SERVER_CODE_MAP);

export const isSupportedLanguage = (language) => {
    return SUPPORTED_LANGUAGES.includes(language);
};

export const getLanguageServerCode = (language) => {
    return LANGUAGE_SERVER_CODE_MAP[language] || LANGUAGE_SERVER_CODE_MAP[DEFAULT_LANGUAGE];
}
